module.exports = __webpack_public_path__ + "img/face-grin-tongue.2970d591.svg";